import { render, staticRenderFns } from "./FourColumnsBanner.vue?vue&type=template&id=02aa850c&"
import script from "./FourColumnsBanner.vue?vue&type=script&lang=js&"
export * from "./FourColumnsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports